import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import axios from "axios";
import './TPDSStockVerificationReport.css'
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { format } from 'date-fns';
import ExcelJS from 'exceljs';
import pomisHeaderImage from './pomisHeader.jpeg';

import pds from './pds.PNG';
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const TPDSStockVerificationReport = () => {
    const [godownOptions, setGodownOptions] = useState([]); // Store the fetched FPS options

    const [districtUid, setDistrictUid] = useState('');
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState('');
    const [panchayatUid, setPanchayatUid] = useState('');
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);

    const [godownId, setGodownId] = useState("");
    const [godownUniqueId, setGodownUniqueId] = useState("");
    const [fpsUniqueId, setFpsUniqueId] = useState("");
    const [fpshops, setFPShops] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [error, setError] = useState(null);  // Define setError here
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);  // Control visibility of DOWNLOAD PDF button
    const [showTable, setShowTable] = useState(false);
    const [stockData, setStockData] = useState([]);
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    // Determine the minimum date for the endDate date picker
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(2025, 0, 1); // January 1st of current year

    // const stockData = [
    //     {
    //         district: "District 1",
    //         subDivision: "Sub Division 1",
    //         block: "Block 1",
    //         panchayat: "Panchayat 1",
    //         fpsId: "FPS-001",
    //         inspectionDate: "01-01-2024",
    //         officerName: "John Doe",
    //         phhWheat: 500.5,
    //         aayWheat: 300.3,
    //         phhRice: 600.6,
    //         aayRice: 400.4,
    //         ricePhysical: 590.0,
    //         wheatPhysical: 490.0,
    //         riceDiff: 10.6,
    //         wheatDiff: 10.5
    //     }
    // ];

    // Repeat the stockData array 15 times using Array.from
    // const repeatedStockData = Array.from({ length: 15 }, () => stockData[0]);

    // console.log(repeatedStockData);

    const generatePDF = () => {


        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [290, 300] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });

        doc.setFontSize(18);
        doc.addImage(pds, 'jpeg', 9.5, -1, 273, 43);  // Image format: 'PNG'
        // Assuming doc is an instance of jsPDF

        const pageWidth = doc.internal.pageSize.width;

        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position

        // Set the report title with a styled color
        // Set the report title with a styled color
        const title = 'Godown Stock Verification Report';  // Title for the report

        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);

        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background

        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position

        // Mapping IDs to names for each field
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        const fps = fpshops.find(f => String(f.id) === String(fpsUniqueId));
        //const fpsName = fps ? fps.fpsId : fpsUniqueId; // This line uses fpsId from the found object or falls back to fpsUniqueId.

        // const fps = Object.values(fpshops).find(f => String(f.id) === String(fpsUniqueId));
        const districtName = district ? district.districtName : '';
        const subDivisionName = subDivision ? subDivision.subDivisionName : '';
        const blockName = block ? block.blockName : '';
        const panchayatName = panchayat ? panchayat.panchayatName : '';
        const godownNameId = fps ? fps.godownId : godownUniqueId; // If not found in fpshops, use the typed fpsId
        console.log("fpsName:", godownNameId);
        // console.log(fpsUniqueId);
        console.log(" fpsId:", fpsUniqueId);

        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        let currentYPosition = 55.21;
        let xPosition = 10;
        const columnSpacing = 90; // Space between columns

        // Check if there is data for each table
        const hasDistrict = districtName !== '';
        const hasSubDivision = subDivisionName !== '';
        const hasBlock = blockName !== '';

        const hasPanchayat = panchayatName !== '';
        const hasGodown = godownNameId !== '';

        const hasFromDate = fromDate !== '';
        const hasToDate = toDate !== '';

        // First Table (District, Sub Division, Block)
        if (hasDistrict || hasSubDivision || hasBlock) {
            // First Table (District, Sub Division, Block)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the first table

            // Set font to normal for labels
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);

            // Add labels only if data exists for the fields
            if (hasDistrict) {
                doc.text("District:", xPosition + 5, currentYPosition + 5);
            }
            if (hasSubDivision) {
                doc.text("Sub Division:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }
            if (hasBlock) {
                doc.text("Block:", xPosition + columnSpacing * 2.02, currentYPosition + 5);
            }


            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasDistrict) {
                doc.text(districtName, xPosition + 28, currentYPosition + 5);  // District name (dynamic)
            }
            if (hasSubDivision) {
                doc.text(capitalizeFirstLetter(subDivisionName), xPosition + columnSpacing + 45, currentYPosition + 5);  // Sub Division name (dynamic)
            }
            if (hasBlock) {
                doc.text(blockName, xPosition + columnSpacing * 1.92 + 28, currentYPosition + 5);  // Block name (dynamic)
            }


            currentYPosition += 8;  // Move down for the next row

            // Second Table (Panchayat, FPS ID)
            if (hasPanchayat || hasGodown) {
                // Second Table (Panchayat, FPS ID)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

                // Set font to normal for labels (Panchayat, FPS ID)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels only if data exists
                if (hasPanchayat) {
                    doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
                }
                if (hasGodown) {
                    doc.text("Godown ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }


                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Green color for dynamic data

                // Add dynamic data only if the corresponding field exists
                if (hasPanchayat) {
                    let firstName = panchayatName;
                    doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
                }
                if (hasGodown) {
                    doc.text(godownNameId, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
                }


                currentYPosition += 8;  // Move down for the next row

                // If third table has data, show it
                if (hasFromDate || hasToDate) {
                    // Third Table (From Date, To Date)
                    doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                    // Set font to normal for labels (From Date, To Date)
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0, 0, 0);  // Set text color to black for labels


                    // Add labels for From Date and To Date
                    if (hasFromDate) {
                        doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                    }
                    if (hasToDate) {
                        doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                    }


                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                    // Add dynamic data for From Date and To Date
                    if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                    if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)


                    currentYPosition += 8;  // Move down for the next row
                }
            }

            // If second table has no data, show third table (From Date, To Date)
            else if (!hasPanchayat && !hasGodown && (hasFromDate || hasToDate)) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the first table has no data, show second table (Panchayat, FPS ID) if it has data
        else if (hasPanchayat || hasGodown) {
            // Second Table (Panchayat, FPS ID)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

            // Set font to normal for labels (Panchayat, FPS ID)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels only if data exists
            if (hasPanchayat) {
                doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
            }
            if (hasGodown) {
                doc.text("FPS ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Green color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasPanchayat) {
                let firstName = panchayatName;
                doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
            }
            if (hasGodown) {
                doc.text(godownNameId, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
            }


            currentYPosition += 8;  // Move down for the next row

            // If third table has data, show it
            if (hasFromDate || hasToDate) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels


                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the second table has no data, show the third table (From Date, To Date)
        else if (hasFromDate || hasToDate) {
            // Third Table (From Date, To Date)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

            // Set font to normal for labels (From Date, To Date)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels for From Date and To Date
            if (hasFromDate) {
                doc.text("From Date:", xPosition + 5, currentYPosition + 5);
            }
            if (hasToDate) {
                doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }


            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Orange color for dynamic data
            // Add dynamic data for From Date and To Date
            if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
            if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

            currentYPosition += 8;  // Move down for the next row
        }

        currentYPosition += 5;  // Adjust space for next content if needed

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition + 8, { align: 'right' });
        currentYPosition += 5;

        currentYPosition += 5;  // Adjust space for next content if needed

        // Table Column Titles
        // Table Column Titles
        const headers = [
            // Row 1: Main categories
            [
                { content: 'S. No', rowSpan: 2 },
                { content: 'District', rowSpan: 2 },
                { content: 'Sub Division', rowSpan: 2 },
                { content: 'Block', rowSpan: 2 },
                { content: 'Panchayat', rowSpan: 2 },
                { content: 'Officer Name', rowSpan: 2 },
                { content: 'Date of Inspection', rowSpan: 2 },
                { content: 'Godown ID', rowSpan: 2 },
                { content: 'SCM (mt)', colSpan: 2 },
                { content: 'Physical Verified (mt)', colSpan: 2 },
                { content: 'Stock Difference - Register & Physical (mt)', colSpan: 2 },
                { content: 'Stock Difference - SCM Portal & Physical (mt)', colSpan: 2 },

            ],
            // Row 2: Sub-categories
            [
                { content: 'Rice' },
                { content: 'Wheat' },
                { content: 'Rice' },
                { content: 'Wheat' },
                { content: 'Rice' },
                { content: 'Wheat' },
                { content: 'Rice' },
                { content: 'Wheat' },

            ],
            // Row 3: Final sub-columns
            // [
            //     { content: 'Paraboiled' },
            //     { content: 'Raw' },
            //     { content: ' ' },
            //     { content: 'Paraboiled' },
            //     { content: 'Raw' },
            //     { content: ' ' },
            //     { content: 'Paraboiled' },
            //     { content: 'Raw' },
            //     { content: ' ' },
            // ],
        ];

        // Repeat the stockData 15 times
        // const repeatedStockData = Array.from({ length: 15 }, () => stockData[0]);
        // Prepare the data rows for the table
        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.districtName),
            capitalizeFirstLetter(data.subDivisionName),
            capitalizeFirstLetter(data.blockName),
            capitalizeFirstLetter(data.panchayatName),
            formatFullName(data.officerName),
            new Date(data.startTime).toLocaleDateString('en-GB').replace(/\//g, '-'),
            data.godownId,
            Number(data.scmRiceQty || 0).toFixed(2),
            Number(data.scmWheatQty || 0).toFixed(2),
            Number(data.physicalRiceQty || 0).toFixed(2),
            Number(data.physicalWheatQty || 0).toFixed(2),
            Number(data.regAndPhyRiceQty || 0).toFixed(2),
            Number(data.regAndPhyWheatQty || 0).toFixed(2),
            Number(data.scmAndPhyRiceQty || 0).toFixed(2),
            Number(data.scmAndPhyWheatQty || 0).toFixed(2),




        ]);

        // AutoTable Plugin - Adding Table to PDF
        doc.autoTable({
            head: headers,
            body: rows,
            startY: currentYPosition,

            theme: 'grid',
            headStyles: {
                fontStyle: 'bold',  // Make the header text bold
                textColor: [12, 92, 108],  // White text color for header
                fillColor: [242, 242, 242],  // White text color
                fontSize: 10,
            },
            margin: { top: 30, left: 14 },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 16 },
                2: { cellWidth: 16 },
                3: { cellWidth: 18 },
                4: { cellWidth: 20 },
                5: { cellWidth: 20 },
                6: { cellWidth: 22 },
                7: { cellWidth: 15 },
                8: { cellWidth: 15 },
                9: { cellWidth: 15 },
                10: { cellWidth: 15 },
                11: { cellWidth: 15 },
                12: { cellWidth: 15 },
                13: { cellWidth: 15 },
                14: { cellWidth: 15 },
                15: { cellWidth: 15 },
                16: { cellWidth: 15 },
                17: { cellWidth: 15 },
            },

        });

        // Save the PDF
        doc.save("Godown StockVerificationReport.pdf");


    };
    const generateXl = () => {
        // 1. Get the current date in DD-MM-YYYY format
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // 2. Generate Excel file using ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Godown Verification Report');
        worksheet.mergeCells('A1:Z1');
        worksheet.getCell('A1').value = `Godown Stock Verification Report`;



        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };

        worksheet.mergeCells('A2:Z2');
        worksheet.getCell('A2').value = `Report Date: ${formattedDateTime}`;


        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
        worksheet.getCell('A2').font = { size: 13, bold: true, color: { argb: '00000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        // Define the header row
        // Main Header Row (Row 3)
        // Place it in Row 3 instead of clashing with table headers
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        worksheet.mergeCells('A3:Z3');
        worksheet.getCell('A3').value = `From Date: ${fromDate}                  To Date: ${toDate}`;

        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 13, bold: true, color: { argb: '00000' } };
        worksheet.getCell('A3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }
        };

        worksheet.addRow([
            "S.No", "District", "Sub Division", "Block", "Panchayat",
            "Officer Name", "Date of Inspection", "Godown ID",

            "SCM (mt)", "",
            "Inward on Inspection Day (mt)", "",
            "Outward on Inspection Day (mt)", "",
            "Previous Day (mt)", "",
            "Physical Verified (mt)", "",
            "Stock Difference - Register & Physical (mt)", "",
            "Stock Difference - SCM Portal & Physical (mt)", "",
            "Deteriorated/Unusable Grains (mt)", "",
            "Jimmenama Grains (mt)", "", // ✅ <-- ADD THIS
        ]);
        // This will now be row 4
        worksheet.mergeCells('I4:J4'); // SCM
        worksheet.mergeCells('K4:L4'); // Inward
        worksheet.mergeCells('M4:N4'); // Outward
        worksheet.mergeCells('O4:P4'); // Previous Day
        worksheet.mergeCells('Q4:R4'); // Physical Verified
        worksheet.mergeCells('S4:T4'); // Stock Diff - Reg vs Physical
        worksheet.mergeCells('U4:V4'); // Stock Diff - SCM vs Physical
        worksheet.mergeCells('W4:X4'); // Deteriorated
        worksheet.mergeCells('Y4:Z4'); // Jimmenama

        worksheet.addRow([
            "", "", "", "", "", "", "", "",
            "Rice", "Wheat",   // I, J
            "Rice", "Wheat",   // K, L
            "Rice", "Wheat",   // M, N
            "Rice", "Wheat",   // O, P
            "Rice", "Wheat",   // Q, R
            "Rice", "Wheat",   // S, T
            "Rice", "Wheat",   // U, V
            "Rice", "Wheat",   // W, X
            "Rice", "Wheat"    // Y, Z — this 
        ]); // Now row 5

        // worksheet.mergeCells('I5:J5');
        // worksheet.mergeCells('L5:M5');
        // worksheet.mergeCells('O5:P5');

        // worksheet.addRow([
        //     "", "", "", "", "", "", "", "",
        //     "Parboiled", "Raw", "",
        //     "Parboiled", "Raw", "",
        //     "Parboiled", "Raw", ""
        // ]); // Row 6



        [4, 5].forEach(rowNum => {
            const row = worksheet.getRow(rowNum);
            row.eachCell(cell => {
                cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFA500' }
                };
                cell.border = {
                    top: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // Note: Wheat columns (K4, O4, S4) remain single columns
        // Apply header style: bold, size 12, and orange background
        worksheet.getRow(4).font = { bold: true, size: 12 };
        worksheet.getRow(4).alignment = { horizontal: 'center' }; // Center alignment
        worksheet.getRow(5).alignment = { horizontal: 'center' };
        //  worksheet.getRow(6).alignment = { horizontal: 'center' }; // Center alignment
        // Apply background color to the first row (header row)
        for (let col = 1; col <= 26; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }
        for (let col = 1; col <= 26; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths (ensure to set widths based on your content)
        // Adjust Column Widths for better visibility
        worksheet.columns = [
            { key: 'A', width: 5 },
            { key: 'B', width: 15 },
            { key: 'C', width: 15 },
            { key: 'D', width: 15 },
            { key: 'E', width: 15 },
            { key: 'F', width: 20 },
            { key: 'G', width: 18 },
            { key: 'H', width: 15 },
            { key: 'I', width: 12 },
            { key: 'J', width: 12 },
            { key: 'K', width: 20 },
            { key: 'L', width: 12 },
            { key: 'M', width: 20 },
            { key: 'N', width: 12 },
            { key: 'O', width: 12 },
            { key: 'P', width: 12 },
            { key: 'Q', width: 12 },
            { key: 'R', width: 20 },
            { key: 'S', width: 25 },
            { key: 'T', width: 15 },
            { key: 'U', width: 27 },
            { key: 'V', width: 12 },
            { key: 'W', width: 22 },
            { key: 'X', width: 12 },
            { key: 'Y', width: 12 },
            { key: 'Z', width: 12 },

        ];



        // Add data rows
        stockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1,
                capitalizeFirstLetter(data.districtName),
                capitalizeFirstLetter(data.subDivisionName),
                capitalizeFirstLetter(data.blockName),
                capitalizeFirstLetter(data.panchayatName),
                formatFullName(data.officerName),
                new Date(data.startTime).toLocaleDateString('en-GB').replace(/\//g, '-'),
                data.godownId,

                Number(data.scmRiceQty || 0).toFixed(2),
                Number(data.scmWheatQty || 0).toFixed(2),

                Number(data.inwardRiceQty || 0).toFixed(2),
                Number(data.inwardWheatQty || 0).toFixed(2),

                Number(data.outwardRiceQty || 0).toFixed(2),
                Number(data.outwardWheatQty || 0).toFixed(2),

                Number(data.prevRiceQty || 0).toFixed(2),
                Number(data.prevWheatQty || 0).toFixed(2),

                Number(data.physicalRiceQty || 0).toFixed(2),
                Number(data.physicalWheatQty || 0).toFixed(2),

                Number(data.regAndPhyRiceQty || 0).toFixed(2),
                Number(data.regAndPhyWheatQty || 0).toFixed(2),

                Number(data.scmAndPhyRiceQty || 0).toFixed(2),
                Number(data.scmAndPhyWheatQty || 0).toFixed(2),

                Number(data.detrRiceQty || 0).toFixed(2),
                Number(data.detrWheatQty || 0).toFixed(2),

                Number(data.jimmRiceQty || 0).toFixed(2),
                Number(data.jimmWheatQty || 0).toFixed(2),

            ]);


            // Apply alignment for each cell in the data row
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {
                    // Center alignment for S.No (Serial Number)
                    cell.alignment = { horizontal: 'center' };
                } else if (colNumber >= 2 && colNumber <= 6) {
                    // Left alignment for District to Officer Name (columns 2 to 6)
                    cell.alignment = { horizontal: 'left' };
                } else if (colNumber >= 7 && colNumber <= 26) {
                    // Right alignment for Date of Inspection to Difference in ePos and Physical Stock (columns 7 to 16)
                    cell.alignment = { horizontal: 'right' };
                }
            });
        });



        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'GodownStockVerificationReport.xlsx';
            link.click();
        });

    };



    const handleStartDateChange = (date) => {
        setStartDate(date);       // Set the selected start date
        setEndDate('');           // Clear the end date when start date changes
        setShowCalendar(false);   // Hide the calendar after selection
        setShowTable(false);
    };


    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };
    // Handle the end date change
    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false);
        setShowTable(false);
    };

    // Token you provided (for testing purposes)
    // const token = '7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5';
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const godownUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;

    useEffect(() => {
        if (token) {
            axios
                .get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];

                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }


                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);

    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
            } catch (error) {
                setError("Error fetching sub-divisions");
            }
        } else {
            setSubDivisions([]);
        }
    };



    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setBlocks(response.data.data || []);
            } catch (error) {
                setError("Error fetching blocks");
            }
        } else {
            setBlocks([]);
        }
    };




    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPanchayats(response.data.data || []);
            } catch (error) {
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);
        }
    };
    // const fetchFPShops = async (panchayatId) => {
    //     if (panchayatId) {
    //         try {
    //             const response = await axios.get(`${baseUrl}/villages?filters[panchayat][id][$eq]=${panchayatId}&populate=fairPriceShops&pagination[pageSize]=100`, {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 }
    //             });
    //             const fpsData = response.data.data || [];
    //             const allFps = fpsData.flatMap(item => item.fairPriceShops);
    //             setFPShops(allFps || []);  // Update state with panchayats data
    //             console.log('FPShops:', allFps);  // Debugging the fetched data
    //         } catch (error) {
    //             console.error('Error fetching fpshops:', error);
    //             setError("Error fetching fpshops");
    //         }
    //     } else {
    //         setFPShops([]);  // Reset FP Shops if no Panchayat selected
    //     }
    // };
    const fetchGodownOptions = async () => {
        setIsLoading(true); // Show loading indicator

        // Construct request payload
        const requestData = {};

        if (districtUid) {
            requestData.district = districtUid;
        }
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }
        if (blockUid) {
            requestData.block = blockUid;
        }
        if (panchayatUid) {
            requestData.panchayat = panchayatUid;
        }
        requestData.surveyType = "2";
        try {
            const response = await axios.post(`${godownUrl}/get-godown-by-filters`, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data && response.data.data) {
                setGodownOptions(response.data.data); // Set the fetched FPS options
            } else {
                setGodownOptions([]);
                setError("No godown data found for the selected filters.");
            }
        } catch (error) {
            setError("Error fetching godown options.");
            console.error('Error fetching godown options:', error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };


    useEffect(() => {
        // Fetch FPS options whenever the filters change
        if (districtUid || subDivisionUid || blockUid || panchayatUid) {
            fetchGodownOptions();
        }
    }, [districtUid, subDivisionUid, blockUid, panchayatUid]);

    // const handleFpsSelection = (selectedFpsId) => {
    //     setFpsId(selectedFpsId); // Store the selected FPS ID
    // };

    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports

        console.log('Selected District ID (for filtering):', selectedDistrictId);  // for filtering
        console.log('Selected District UID (for report generation):', selectedDistrictUid);  // for report generation

        // Set both districtId (for filtering) and districtUid (for report generation)
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation

        // Reset everything except subdivision
        setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');

        setSubDivisionId('');  // Reset sub-division
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setFPShops([]);  // Clear FPS shops
        setPanchayats([])
        setBlocks([])
        setShowTable(false);  // Reset table visibility
        fetchSubDivisions(selectedDistrictId);  // Fetch subdivisions based on the selected district
    };

    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";
        console.log('Selected Subdivision:', selectedId);
        console.log('Selected selectdSubDivisionUid:', selectdSubDivisionUid);
        // Reset everything except block
        setSubDivisionUid(selectdSubDivisionUid)
        // setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');

        setSubDivisionId(selectedId);
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setFPShops([]);  // Clear FPS shops 
        setPanchayats([])  //it is not actved panchayats without selecting
        setBlocks([]) //it is not actved block  without selecting
        setShowTable(false);  // Reset table visibility
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision
    };

    const handleBlockChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        console.log('Selected Block:', selectedId);
        console.log('Selected BlockUid:', selectedBlockUid);
        // Reset everything except panchayat
        setBlockId(selectedId);
        setBlockUid(selectedBlockUid);
        setPanchayatUid('');  // Clear panchayatUid
        setPanchayatId('');  // Reset panchayat
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setFPShops([]);  // Clear FPS shops without selecting
        setPanchayats([])  //it is not actved panchayats  without selecting
        setShowTable(false);  // Reset table visibility
        fetchPanchayats(selectedId);  // Fetch panchayats based on the selected block
    };

    const handlePanchayatChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedpanchayatUid = selectedOption ? selectedOption.panchayatUid : '';
        console.log('Selected Panchayat:', selectedId);
        console.log("selected panUid", selectedpanchayatUid);
        setPanchayatUid(selectedpanchayatUid);
        // Reset only FPS ID, as panchayat is selected
        setPanchayatId(selectedId);
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setFPShops([]);  // Clear FPS shops not accepting fps without selecting
        setShowTable(false);  // Reset table visibility
        // fetchFPShops(selectedId);  // Fetch FPS shops based on the selected panchayat
    };

    const handleGodownId = (selectedOption) => {
        const selectedGodownId = selectedOption ? selectedOption.value : '';
        const selectedGodownUniqueId = selectedOption ? selectedOption.label : '';

        console.log('Selected godo:', selectedGodownId);
        console.log('unique normal ', selectedGodownUniqueId)
        setGodownId(selectedGodownId);  // Save the selected FPS ID
        setGodownUniqueId(selectedGodownUniqueId);  // Save the selected FPS Unique ID
        //setGodownUniqueId('');
        // setFpsId('');  
        setShowTable(false);  // Show the table after FPS ID is selected
    };

    // Function to clear all data (reset state)
    const handleClear = () => {
        setGodownId('');
        setDistrictUid(null);
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        setStartDate('');
        setEndDate('');
        setShowDownloadButton(false);
        setShowTable(false);
    };


    const handleGenerateReport = () => {
        // if (!startDate || !endDate || !districtId) {
        //     setError("Please select both start date and end date.");
        //     alert("Please select both start date and end date.");
        //     return;
        // }

        // // Ensure startDate is before endDate (basic validation)
        // if (startDate > endDate) {
        //     setError("Start date cannot be later than end date.");
        //     alert("Start date cannot be later than end date.");
        //     return;
        // }
        if (startDate && endDate && startDate > endDate) {
            setError("Start date cannot be later than end date.");
            alert("Start date cannot be later than end date.");
            return;
        }
        // Set loading state before making the request
        setIsLoading(true);  // Show loading message immediately
        setShowTable(true);
        setStockData([]);  // Clear previous data

        const formatDate = (date) => {
            if (!date) return null;
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
            const year = date.getFullYear();
            return `${year}-${month}-${day}`;
        };

        // Prepare request data
        const requestData = {};

        // Add startDate and endDate to the requestData if available
        if (startDate) {
            requestData.startDate = formatDate(startDate);
        }

        if (endDate) {
            requestData.endDate = formatDate(endDate);
        }

        // Add districtId to the requestData if selected
        // Add districtId to the requestData if selected (only if needed)
        if (districtUid) {
            requestData.districtUid = districtUid;
            requestData.surveyType = "2";
        } else if (!districtUid && !godownId && !godownUniqueId) {
            // If no godownId and no districtUid, set default as "All"
            requestData.districtUid = "All";
            requestData.surveyType = "2";
        }

        // Add other optional parameters like subDivision, block, panchayat, godownId
        if (subDivisionUid) {
            requestData.subDivisionUid = subDivisionUid;
        }

        if (blockUid && blockUid !== "") {
            requestData.blockUid = blockUid;
        }

        if (panchayatUid && panchayatUid !== "") {
            requestData.panchayatUid = panchayatUid;
        }

        if (godownUniqueId) {
            requestData.godownId = godownUniqueId;  // Use godownUniqueId if it's available
        } else if (godownId) {
            requestData.godownId = godownId;  // Otherwise, use godownId
        }


        console.log(requestData);  // Log the request data for debugging


        // Make the POST request to fetch the report
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/reports/godown-stock-verification`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then((response) => {
                setIsLoading(false);
                if (response.data && response.data.length > 0) {
                    console.log(response.data);
                    setStockData(response.data);  // Set table data
                    setShowDownloadButton(true); // Show download button
                    setShowTable(true);   // Show the table
                } else {
                    setStockData([]); // Clear previous data
                    setError("Loading...");
                    setShowDownloadButton(false); // Hide download but  ton
                    setShowTable(true); // Still show the table even if it's empty
                    // alert("No data available for the selected date range.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching report.");
                console.error('Error fetching report:', error);
                setShowDownloadButton(false); // Hide download button if there was an error
                setShowTable(true); // Show the table even if there's an error
            });


    };

    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.districtName || '';
            const districtB = b.districtName || '';
            const subDivisionA = a.subDivisionName || '';
            const subDivisionB = b.subDivisionName || '';
            const blockA = a.blockName || '';
            const blockB = b.blockName || '';
            const panchayatA = a.panchayatName || '';
            const panchayatB = b.panchayatName || '';

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };

    // Sorted data before rendering
    const sortedStockData = sortData(stockData);
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    //   const formatDate = (date) => {
    //     if (!date) return '';
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    //     const year = date.getFullYear();
    //     return `${day}-${month}-${year}`;
    // };
    // console.log(stockData); // Log this to the console


    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
    };
    return (
        <div className="godownstock-repo">
            {/* <div className="fpsstockdeviationname">
                    <p>FPS Stock Deviation Report</p>
                </div> */}

            <div className="godownstock-1-repo">
                <div className="godownstock-card-header-testing-stock-repo">TPDS Godown Stock Verification Report</div>
                <div className='godownstock-whole-div'>
                    <div className="stockgodown-mainBlock-testing-stock-repo">
                        <div className="stockgodown-group-cu-testing-stock-repo">
                            <label htmlFor="district" className="district-items-testing-godown-repo">
                                <span className="asterisk">*</span>District
                            </label>
                            <Select
                                className="search-select"
                                id="district"
                                // Ensure you pass the selected option as an object with value and label
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts
                                    .sort((a, b) => a.districtName.localeCompare(b.districtName))  // Sort by districtName alphabetically
                                    .map((dist) => ({
                                        value: dist.id,
                                        label: capitalizeFirstLetter(dist.districtName),
                                        districtUid: dist.districtUid,  // Add districtUid for report generation
                                    }))
                                }
                                placeholder="Select a district"
                                isSearchable // Enable search in the dropdown
                                styles={customStyles} // Apply custom styles here
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown} // Trigger dropdown open
                                onMenuClose={toggleDropdown} // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>


                        <div className="stockgodown-group-cu-testing-stock-repo">
                            <label htmlFor="subDivision">{/*<span className="asterisk">*</span>*/}Godown ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="search-select"
                                    id="fps"
                                    value={godownId ? {
                                        value: godownId,
                                        label: godownOptions.find((godo) => godo.id === godownId)?.godownId  // Use godownId for label
                                    } : null}
                                    onChange={handleGodownId}
                                    options={godownOptions.sort((a, b) => a.godownId.localeCompare(b.godownId))
                                        .map((godo) => ({
                                            value: godo.id,
                                            label: godo.godownId,  // Display the godownId as label
                                            godownUniqueId: godo.godownUniqueId,  // Include godownUniqueId for report generation
                                        }))}
                                    placeholder="Select Godown Shop"
                                    isSearchable
                                    styles={customStyles}
                                    // required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="inspection-search-select-1"
                                    type="text"
                                    placeholder="Enter Godown ID"
                                    value={godownId}
                                    onChange={(e) => setGodownId(e.target.value)}
                                    style={{ padding: '5px' }}
                                />
                            )}
                        </div>

                        <div className="stockgodown-group-cu-testing-1-stock-repo">
                            <div className="stockgodown-devi-buttons">
                                <button className="stockgodown-buttons" onClick={handleClear}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                        !(godownId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                    }
                                >CLEAR
                                </button>

                                <button
                                    className="stockgodown-buttons"
                                    onClick={handleGenerateReport}
                                    disabled={!(godownId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))}
                                >
                                    GENERATE REPORT
                                </button>
                            </div>

                        </div>

                    </div>

                    {/* <div className="stockgodown-mainBlock-testing-1-stock-repo"> */}
                    {/* <div className="stockgodown-group-cu-testing-1-stock-repo">
                            <label htmlFor="panchayat" className="district-items-testing-stock">Panchayat</label>
                            <Select
                                className="search-select"
                                id="panchayat"
                                value={panchayatId ? {
                                    value: panchayatId,
                                    label: capitalizeFirstLetter(panchayats.find((p) => p.id === panchayatId)?.panchayatName)
                                } : null}
                                onChange={handlePanchayatChange}
                                options={panchayats.sort((a, b) => a.panchayatName.localeCompare(b.panchayatName))
                                    .map((p) => ({
                                        value: p.id,
                                        label: capitalizeFirstLetter(p.panchayatName,),
                                        panchayatUid: p.panchayatUid,
                                    }))}
                                placeholder="Select Panchayat"
                                isSearchable
                                styles={customStyles}
                                // required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div> */}

                    {/* <div className="stockgodown-group-cu-testing-1-stock-repo">
                            <label htmlFor="subDivision">Godown ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="search-select"
                                    id="fps"
                                    value={godownId ? {
                                        value: godownId,
                                        label: godownOptions.find((godo) => godo.id === godownId)?.godownId  // Use godownId for label
                                    } : null}
                                    onChange={handleGodownId}
                                    options={godownOptions.sort((a, b) => a.godownId.localeCompare(b.godownId))
                                        .map((godo) => ({
                                            value: godo.id,
                                            label: godo.godownId,  // Display the godownId as label
                                            godownUniqueId: godo.godownUniqueId,  // Include godownUniqueId for report generation
                                        }))}
                                    placeholder="Select Godown Shop"
                                    isSearchable
                                    styles={customStyles}
                                    // required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="inspection-search-select-1"
                                    type="text"
                                    placeholder="Enter Godown ID"
                                    value={godownId}
                                    onChange={(e) => setGodownId(e.target.value)}
                                    style={{ padding: '5px' }}
                                />
                            )}
                        </div> */}

                    {/* <div className="stockgodown-group-cu-testing-1-stock-repo">
                            <div className="stockgodown-devi-buttons">
                                <button className="stockgodown-buttons" onClick={handleClear}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                        !(godownId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                    }
                                >CLEAR
                                </button>

                                <button
                                    className="stockgodown-buttons"
                                    onClick={handleGenerateReport}
                                    disabled={!(godownId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))}
                                >
                                    GENERATE REPORT
                                </button>
                            </div>

                        </div> */}

                    {/* </div> */}

                    <div className="stockgodown-mainBlock-testing-2-stock-repo">
                        <div className="stockgodown-group-cu-testing-2-stock-repo">
                            <label htmlFor="startDate" className="district-items-testing-godown-repo"><span className="asterisk">*</span>From Date</label>
                            <div className="stockgodown-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="stockgodown-input-repo"
                                    value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowCalendar(true)}
                                />
                                <div className="stockgodown-icon-test-stock-repo" onClick={() => setShowCalendar(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                        maxDate={currentDate} // Today
                                    />
                                )}
                            </div>
                        </div>


                        <div className="stockgodown-group-cu-testing-2-stock-repo">
                            <label htmlFor="startDate" className="district-items-testing-godown-repo"><span className="asterisk">*</span>To Date</label>
                            <div className="stockgodown-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="stockgodown-input-repo"
                                    value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowEndCalendar(true)}
                                    disabled={!startDate}
                                />
                                <div className="stockgodown-icon-test-stock-repo" onClick={handleEndDateIconClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}

                                        // onChange={(date) => {
                                        //     setEndDate(date);
                                        //     setShowEndCalendar(false);
                                        // }}
                                        onClickOutside={() => setShowEndCalendar(false)}
                                        minDate={startDate} // End date can't be before the start date
                                        maxDate={currentDate} // End date can't be after today

                                        inline
                                    />
                                )}
                            </div>
                        </div>

                        <div className="stockgodown-group-cu-testing-2-stock-repo">
                            {/* Conditionally Render GET REPORT Button */}



                            {/* Conditionally Render DOWNLOAD PDF Button */}
                            {(godownId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate)) && showDownloadButton && showTable && (
                                <div className="stockgodown-devi-buttons">
                                    <button onClick={generatePDF} className="stockgodown-buttons">
                                        DOWNLOAD PDF
                                    </button>
                                    <button onClick={generateXl} className="stockgodown-buttons">
                                        DOWNLOAD XLSX
                                    </button>
                                </div>

                            )}
                        </div>

                    </div>
                </div>
            </div>

            <div className="stockgodown-main-repo">
                <table className="stockgodown-table-repo">
                    <thead>
                        <tr>
                            <th rowSpan="2">S.No</th>
                            <th rowSpan="2">District</th>
                            <th rowSpan="2">Sub Division</th>
                            <th rowSpan="2">Block</th>
                            <th rowSpan="2">Panchayat</th>
                            <th rowSpan="2">Officer Name</th>
                            <th rowSpan="2">Date of Inspection</th>
                            <th rowSpan="2">Godown ID</th>
                            <th colSpan="2">SCM (mt)</th>
                            <th colSpan="2">Inward on Inspection Day (mt)</th>
                            <th colSpan="2">Outward on Inspection Day (mt)</th>
                            <th colSpan="2">Previous Day (mt)</th>
                            <th colSpan="2">Physical Verified (mt)</th>
                            <th colSpan="2">Stock Difference - Register & Physical (mt)</th>
                            <th colSpan="2">Stock Difference - SCM Portal & Physical (mt)</th>
                            <th colSpan="2">Deteriorated/Unusable Grains (mt)</th>
                            <th colSpan="2">Jimmenama Grains (mt)</th>
                            {/* <th colSpan="2">Physically Verified Quantity(Mt)</th>
                            <th colSpan="2">Difference in ePos and Physical Stock(Mt)</th> */}
                        </tr>
                        <tr>
                            <th >Rice</th>
                            <th>Wheat</th>

                            <th >Rice</th>
                            <th>Wheat</th>
                            <th >Rice</th>
                            <th>Wheat</th>
                            <th >Rice</th>
                            <th>Wheat</th>

                            <th >Rice</th>
                            <th>Wheat</th>
                            <th >Rice</th>
                            <th>Wheat</th>
                            <th >Rice</th>
                            <th>Wheat</th>

                            <th >Rice</th>
                            <th>Wheat</th>
                            <th >Rice</th>
                            <th>Wheat</th>
                        </tr>
                        {/* <tr >
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                            <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                            <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                              <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                            <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                            <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                              <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                            <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                            <th>Paraboiled</th>
                            <th>Raw</th>
                            <th></th>
                        </tr> */}
                    </thead>
                    {showTable && (
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="14" style={{ textAlign: 'center' }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : sortedStockData.length > 0 ? (
                                sortedStockData.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{capitalizeFirstLetter(entry.districtName)}</td>
                                        <td>{capitalizeFirstLetter(entry.subDivisionName)}</td>
                                        <td>{capitalizeFirstLetter(entry.blockName)}</td>
                                        <td>{capitalizeFirstLetter(entry.panchayatName)}</td>
                                        <td>{formatFullName(entry.officerName)}</td>
                                        <td>{new Date(entry.startTime).toLocaleDateString('en-GB').replace(/\//g, '-')}</td>
                                        <td>{entry.godownId}</td>
                                        <td>{Number(entry.scmRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.scmWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.inwardRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.inwardWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.outwardRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.outwardWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.prevRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.prevWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.physicalRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.physicalWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.regAndPhyRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.regAndPhyWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.scmAndPhyRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.scmAndPhyWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.detrRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.detrWheatQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.jimmRiceQty || 0).toFixed(2)}</td>
                                        <td>{Number(entry.jimmWheatQty || 0).toFixed(2)}</td>

                                        {/* <td>
                                            {(entry.questionSurveys?.[0]?.response
                                                ? formatNumber(parseFloat(entry.questionSurveys?.[0]?.response).toFixed(2))
                                                : 'N/A')}
                                        </td>
                                        <td>
                                            {(entry.questionSurveys?.[1]?.response
                                                ? formatNumber(parseFloat(entry.questionSurveys?.[1]?.response).toFixed(2))
                                                : 'N/A')}
                                        </td>
                                        <td>
                                            {(entry.questionSurveys?.[2]?.response
                                                ? formatNumber(parseFloat(entry.questionSurveys?.[2]?.response).toFixed(2))
                                                : 'N/A')}
                                        </td>
                                        <td>
                                            {(entry.questionSurveys?.[3]?.response
                                                ? formatNumber(parseFloat(entry.questionSurveys?.[3]?.response).toFixed(2))
                                                : 'N/A')}
                                        </td>
                                        <td>
                                            {(entry.questionSurveys?.[4]?.response
                                                ? formatNumber(parseFloat(entry.questionSurveys?.[4]?.response).toFixed(2))
                                                : 'N/A')}
                                        </td>
                                        <td>
                                            {(entry.questionSurveys?.[5]?.response
                                                ? formatNumber(parseFloat(entry.questionSurveys?.[5]?.response).toFixed(2))
                                                : 'N/A')}
                                        </td>
                                        <td>
                                            {
                                                typeof entry.questionSurveys?.[6]?.response === 'number' && !isNaN(entry.questionSurveys?.[6]?.response)
                                                    ? formatNumber(entry.questionSurveys?.[6]?.response.toFixed(2))
                                                    : (entry.questionSurveys?.[6]?.response && !isNaN(parseFloat(entry.questionSurveys?.[6]?.response)))
                                                        ? formatNumber(parseFloat(entry.questionSurveys?.[6]?.response).toFixed(2))
                                                        : 'N/A'
                                            }
                                        </td>
                                        <td>
                                            {
                                                typeof entry.questionSurveys?.[7]?.response === 'number' && !isNaN(entry.questionSurveys?.[7]?.response)
                                                    ? formatNumber(entry.questionSurveys?.[7]?.response.toFixed(2))
                                                    : (entry.questionSurveys?.[7]?.response && !isNaN(parseFloat(entry.questionSurveys?.[7]?.response)))
                                                        ? formatNumber(parseFloat(entry.questionSurveys?.[7]?.response).toFixed(2))
                                                        : 'N/A'
                                            }
                                        </td> */}

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="14" style={{ textAlign: 'center', color: 'red' }}>
                                        No Data Available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>

        </div>
    );
}
export default TPDSStockVerificationReport;